module.exports = __webpack_public_path__ + "static/media/ListRectangular.c41724af.svg";